import { useDispatch, useSelector } from "react-redux";
import { downloadMemberContractsReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useMemberContractsReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.memberContracts.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadMemberContractsReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
